export enum Shadow {
    Connman = 'connman',
    Datasyncd = 'datasyncd',
    Gsm = 'gsm',
    System = 'system',
    Vend = 'vend',
}